import { route } from "ziggy-js"

export default {
  show(params) {
    return axios.get(
      route("client-portal.payment-method-request.show", {
        paymentMethodRequest: params.payment_method_request,
        token: params.token,
      }),
    )
  },

  complete(params) {
    return axios.post(
      route("client-portal.payment-method-request.complete", {
        paymentMethodRequest: params.payment_method_request,
        token: params.token,
        setup_intent_id: params.setup_intent_id,
      }),
    )
  },
}
